import { render, staticRenderFns } from "./HandlingFee.vue?vue&type=template&id=fa83eea8&scoped=true&"
import script from "./HandlingFee.vue?vue&type=script&lang=js&"
export * from "./HandlingFee.vue?vue&type=script&lang=js&"
import style0 from "./HandlingFee.vue?vue&type=style&index=0&id=fa83eea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa83eea8",
  null
  
)

export default component.exports